export { default as ErrorPage, withErrorPage, defaultErrorPayload } from './error-page';
